var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container lnb d_container"},[_c('div',{staticClass:"contents_wrap"},[_c('div',{staticClass:"contents list-container"},[_c('div',{staticClass:"title"},[_vm._v("nickname 신청정보")]),_c('div',[_c('member-write-component',{attrs:{"memberType":`curatorUpdate`,"memberKey":_vm.memberKey}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }